import { render } from "./HLACLASSIIISABTYPING.vue?vue&type=template&id=3722b189&scoped=true"
import script from "./HLACLASSIIISABTYPING.vue?vue&type=script&lang=js"
export * from "./HLACLASSIIISABTYPING.vue?vue&type=script&lang=js"

import "./HLACLASSIIISABTYPING.vue?vue&type=style&index=0&id=3722b189&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3722b189"]])

export default __exports__